import { Typography } from "@material-ui/core"
import { PriceItem } from "api"
import { formatPrice } from "common/price"
import styled from "styled-components"
import { Font } from "../../constants"
import LicensingFee from "../LicensingFee"
import NextStepButton from "../NextStepButton"

const StyledPrice = styled(Typography)`
  font-family: ${Font.MazdaType};
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.08em;
`
const StyledContainer = styled.div<{ discount?: boolean }>`
  padding: 10px;
  margin: 0;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px -1px 4px rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  background-color: #ffffff;
  height: 100%;
`

const StyledPriceAndBtnContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const TotalPriceMobile = ({ price }: { price: PriceItem }) => (
  <StyledContainer discount={price.discount > 0}>
    <StyledPriceAndBtnContainer>
      <StyledPrice>{formatPrice(price.totalPrice)}</StyledPrice>
      <NextStepButton />
    </StyledPriceAndBtnContainer>
    <LicensingFee />
  </StyledContainer>
)

export default TotalPriceMobile
